( function ( $, w) {
  function parseCustomHtmlData() {
    $('[id^="slider-"] .slick-initialized').each(
      (sliderBlockIndex, sliderBlock) => {
        $(sliderBlock)
          .find(".slick-slide:not(.slick-cloned) .slick-slide-wrapper")
          .each((_index, sliderWrapper) => {
            let customHtml = $(sliderWrapper).data("customhtml")
              ? JSON.parse($(sliderWrapper).data("customhtml"))
              : "";
            if (customHtml) {
              assignCustomHtmlTosliderDot(_index, customHtml, sliderWrapper);
            }
          });
      }
    );
  }
  function assignCustomHtmlTosliderDot(slideIndex, customHtml, sliderWrapper) {
    $(sliderWrapper)
      .closest(".slick-dotted")
      .find(".slick-dots")
      .addClass("slick-custom-dots")
      .find("li:eq(" + slideIndex + ") button")
      .addClass("slick-custom-dot")
      .html(customHtml);
  }

  // Calls when the window is fully loaded
	$(w).on( 'load', ( event ) => {
		parseCustomHtmlData();
	});
  // Calls on window resize
  $(w).on("resize", debounce(parseCustomHtmlData, 500));
} )( jQuery, window );
